'use strict'

import '../scss/main.scss'

window.$ = window.jQuery = require('jquery');

import 'bootstrap';

// Image lazy loading
window.lozad = require('lozad');


// Mouse wheel
require('jquery-mousewheel')($);

window.owlCarousel = require('owl.carousel')


window.designamite = {

  init()
  {

    designamite.global.init()
    
    designamite.cookie.init()

  },

  global: require('./methods/global'),
  
  cookie: require('./methods/cookie-bar'),

}

designamite.init()